<template>
    <div class="notice col" :class="{mobile:$vuetify.breakpoint.xs, pickedNotice: picked_notice && (notice._id == picked_notice._id)}" >
        <div class="notice-content relative">
            <!-- <v-subheader v-if="search" class="path" @click ="toNotice()">{{notice.parent_name}}</v-subheader> -->
            <!-- <v-btn class="close_button" small icon @click="del"><v-icon size="14">close</v-icon></v-btn>             
            <v-btn class="right" small icon @click="setComplete">
                {{completedInFeedAndTask ? "✔️" : "✓" }}
            </v-btn> -->
            <img v-if="!menu" @click="menu = !menu" src="@/assets/images/components/menu-horizontal.svg" class="right pointer mr-2">
            <img v-if="menu" @click="menu = !menu" src="@/assets/images/components/menu-horizontal-active.svg" class="right pointer mr-2">
            <div v-if="!completedInFeedAndTask">
                <div v-if="menu" class="absolute menu text-capitalize text-left">
                    <div class="active">
                        <div @click="setComplete" class="roboto-normal-14 clr-black-38 py-2 pl-4 pointer">В архив</div>
                    </div>
                </div>
            </div>
            <div v-else>
                <div v-if="menu" class="absolute menu text-capitalize text-left pointer">
                    <div>
                        <div class="roboto-normal-14 clr-black-38 py-2 pl-4" disabled>В архив</div>
                    </div>
                    <div class="active">
                        <div @click="setComplete" class="roboto-normal-14 clr-black-38 py-2 pl-4">Восстановить</div>
                    </div>
                    <div class="active">
                        <div @click="del" class="roboto-normal-14 clr-black-38 py-2 pl-4">Удалить</div>
                    </div>
                </div>
            </div>          
            <textarea v-model="noticeBody" v-if="low" class="w-100"/>
            <TTextArea v-model="noticeBody" rows="10" :no-editor="true" v-else/>
            <Images :images="imagesForNotice" @deleteImage="val  => deleteFile(val)"/>
        </div>
        <div class="flex-center-between" v-if="!low" @click ="toNotice()">
            <div class="time">{{moment(+new Date(notice.createdAt)).calendar()}}</div>
            <!-- <Pushes :item="notice" />             -->
        </div>
    </div>
</template>

<script>
	import Pushes from './../main/pushes/Pushes'
    import { mapActions, mapGetters, mapMutations } from 'vuex'
    import { debounce } from 'lodash'
    import TTextArea from '../misc/TTextArea'
    import Images from '../popups/Images'
    import moment from 'moment'
    export default {
        name: 'Notice',
        components: {
            Pushes,
            TTextArea,
            Images
        },
        props: [
            'notice',
            'search',
            'low'
        ],
        data() {
            return {
                menu: false,
            }
        },
        computed:{
          ...mapGetters(["current", "current_task", "current_feed","feeds", "picked_notice", 'feeds']),
            noticeBody:{
                get(val){
                    return this.notice.body
                },
                set: debounce(function(newVal) {
                    this.editNotice({feed_id: this.current_feed._id, notice_id: this.notice._id, text: newVal})
                }, 450)
            }, 
            isNoticeRelevant() {
                return true ? this.$route.name == "themes" : this.$route.name == "feeds"
            },
            completedInFeedAndTask() {
                return !this.isNoticeRelevant ? this.notice.completedInFeed : this.current && this.current_task && this.notice && ~this.notice.completedInTasks.indexOf(this.current_task._id) 
            },
            regexpForNotice() {
                if(!this.notice.body) return []
                const regexp = /(\(.*?)?\b((?:https?|ftp|file):\/\/[-a-z0-9+&@#\/%?=~_()|!:,.;]*[-a-z0-9+&@#\/%=~_()|])/ig
                const links = this.notice.body.match(regexp)
                if (links) {
                    const regexpLinks = new RegExp('http(?::\\/\\/|s:\\/\\/).*?\\.(?:gif|jpg|jpeg|png)', 'i')
                    const filteredLinks = [...links.map(el => el.split('"').join(''))].filter(el =>  el.match(regexpLinks))
                    return filteredLinks.map(el => el.replace(new RegExp("amp;", 'g'), "")) 
                } else return []
            },
            imagesForNotice() {
                const set = this.regexpForNotice && [...(this.notice.blockedLinks || [])] && new Set(this.notice.blockedLinks)
                const links = this.regexpForNotice.filter(e => !set.has(e))
                const noticeImages = this.notice.images && this.notice.images.map((el) => this.$root.origin + '/api' + el)
                return [...(noticeImages || []), ...links]
            }
        },
        methods:{
            ...mapMutations(["SET_CURRENT_FEED"]),
            ...mapActions(['editNotice', 'delNotice', 'setCompletedNotice', 'toggleCompletedRelevantNotice', 'setImagesToNotice', 'setBlockedLinksToNotice']),
            async setComplete (){
                //1674
                //1533 - wo v-btn
                //800 - textrea 680 - just div
                //400 - pushes
                const time0 = +new Date()
                if (!this.isNoticeRelevant) {
                    await this.setCompletedNotice({feed_id: this.current_feed._id, notice_id: this.notice._id, value: !this.notice.completedInFeed})
                } else {
                    await this.toggleCompletedRelevantNotice({current_task_id: this.current_task._id, notice: this.notice})
                }
                console.log(+new Date() - time0);
                this.menu = false
            },
            del(){
                this.delNotice({feed_id: this.current_feed._id, notice_id: this.notice._id}).then(() => {
                    this.rename_flag = false
                })          
                this.menu = false         
            },
            moment,
            toNotice() {
                const feed = this.feeds.find(feed => {
                    return feed.notices.find(el => el._id == this.notice._id)
                })
                this.SET_CURRENT_FEED(feed)
                this.feedBody = feed.body  
                this.$emit('toCloseWindow')
                this.$root.$emit('selectElementMenu')
                this.$router.push({path:`/feeds/${feed.route_name}#notice-id-${this.notice._id}`})
                let oldScroll = window.scrollY
                const toHash = setInterval(() => {
                    const elementNotice = document.getElementById(`notice-id-${this.notice._id}`)
                    if (elementNotice) { 
                        this.$vuetify.goTo(`#notice-id-${this.notice._id}`)
                    }
                    if (oldScroll != window.scrollY || oldScroll == 0) {
                        clearInterval(toHash)
                    } 
                    oldScroll = window.scrollY
                },30)
            },
            async deleteFile(e) {
                if (e.includes(this.$root.origin + "/api")) {
                    this.notice.images.splice(this.notice.images.findIndex(image => image == e.slice(24)),1)
                    await this.setImagesToNotice({feed_id: this.feeds[0]._id, notice_id: this.notice._id, images: [...(this.notice.images || [])]})
                } else {
                    this.notice.blockedLinks.push(e)
                    await this.setBlockedLinksToNotice({feed_id: this.feeds[0]._id, notice_id: this.notice._id, blockedLinks: [...(this.notice.blockedLinks || [])]})
                }
            }
        },
        created() {
            
        },
    }
</script>

<style lang="scss" scoped>
    .notice.mobile{
        min-width: 100%;  
    }
    .notice{
        max-height:352px;
        border: 1px solid #F2F2F2;
        box-sizing: border-box;
        border-radius: 7px;
        &.pickedNotice {
            border: 1px solid black;
        }
        .notice-content {
            min-height:110px;
            max-height:300px;
            overflow:hidden;
            .menu {
                right:50px;
                background: #FFFFFF;
                width: 158px;
                box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.25);
                .active {
                    &:hover {
                        background:  #18A0FB;;
                    }
                }
            }
        }
        .v-subheader {
            justify-content: center;
            height: 40px;
        }
        .path {
            font-size: .800rem;
            text-decoration: underline;
            color: #1976d2;
            cursor: pointer;
        }       
    }
    .time{
        padding-left: 5px;
        font-family: Roboto;
        font-style: italic;
        font-weight: normal;
        font-size: 18px;
        line-height: 23px;
        color: #BEBEBE;
    }
    .close_button{
        float: right;
        opacity: .3;
        &:hover{
            opacity: 1;
        }
    }
    .v-time-picker-clock__hand{
        background: #b9f3a6 !important;
    }
</style>